import { useQuery } from '@apollo/client';
import { gql } from '__generated__/gql';
import dayjs from 'dayjs';
import { useNavigate, useParams } from 'react-router-dom';

import FocusLayout from 'layouts/FocusLayout';

import ErrorMessage from 'components/ErrorMessage';

import LoadingIndicator from 'primitives/LoadingIndicator';

import FundInformation from './FundInformation';
import PassFundDialogButton from './PassDealDialogButton';

const FUND_QUERY = gql(`
  query GetFundInvite($id: ID!) {
    fundInvite(id: $id) {
      id
      status
      fund {
        id
        name
        description
        image
        closingDate
      }
    }
  }
`);

const FundInvitesPage = () => {
  const navigate = useNavigate();
  const { fundInviteLinkId } = useParams<{ fundInviteLinkId: string }>() as {
    fundInviteLinkId: string;
  };

  const { data, loading, error } = useQuery(FUND_QUERY, {
    variables: { id: fundInviteLinkId },
  });

  if (loading) return <LoadingIndicator />;

  if (error) return <ErrorMessage error={error} />;

  if (data?.fundInvite.status === 'COMMITTED') {
    navigate(`/`); // TODO: Redirect to the fund Page
  }

  return (
    <FocusLayout>
      <FundInformation fund={data?.fundInvite?.fund} />
      <div className="fixed bottom-4 left-0 right-0">
        <div className="mx-auto max-w-3xl bg-white shadow-2xl p-4 grid grid-cols-6 gap-x-3 border-2 border-indigo-100 rounded-lg">
          <div className="col-span-2">
            <h2 className="text-2xl font-medium">Invest</h2>
            <p className="text-sm text-gray-400 my-1">
              Deadline: {dayjs(data?.fundInvite?.fund?.closingDate).format('MMMM DD, YYYY')}
            </p>
          </div>
          <div className="col-span-2 h-full">
            <PassFundDialogButton fundId={data?.fundInvite?.fund?.id} />
          </div>
          <button
            onClick={() => navigate(`/invest/fund-invites/${fundInviteLinkId}/confirm`)}
            className="col-span-2 w-full rounded-md border border-transparent bg-indigo-600 px-4 py-3 text-base font-medium text-white shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 focus:ring-offset-gray-50"
          >
            Invest
          </button>
        </div>
      </div>
    </FocusLayout>
  );
};

export default FundInvitesPage;
